import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "toolbar", "count"]

  connect() {
    this.#updateState()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(cb => { cb.checked = checked })
    this.#updateState()
  }

  toggle() {
    this.#syncSelectAll()
    this.#updateState()
  }

  // Called by toolbar "Bulk Approve" / "Bulk Reject" buttons.
  // Sets the form action to the button's data-url before native submission.
  bulkSubmit(event) {
    const url = event.currentTarget.dataset.url
    if (url) this.element.action = url
  }

  // Called by per-row "Approve" / "Reject" links.
  // Ensures the clicked row's checkbox is checked (so the page_id is included),
  // then submits the bulk form to the action specified by data-url.
  // Any other already-checked rows are also submitted, matching user expectation.
  rowAction(event) {
    event.preventDefault()

    const row = event.currentTarget.closest("tr")
    const checkbox = row?.querySelector("[data-admin-bulk-select-target='checkbox']")
    if (checkbox && !checkbox.checked) {
      checkbox.checked = true
      this.#syncSelectAll()
      this.#updateState()
    }

    const url = event.currentTarget.dataset.url
    if (url) this.element.action = url
    this.element.requestSubmit()
  }

  #syncSelectAll() {
    if (!this.hasSelectAllTarget) return
    const total = this.checkboxTargets.length
    const checkedCount = this.#checkedCount()
    this.selectAllTarget.checked = total > 0 && checkedCount === total
    this.selectAllTarget.indeterminate = checkedCount > 0 && checkedCount < total
  }

  #updateState() {
    const count = this.#checkedCount()
    if (this.hasToolbarTarget) {
      this.toolbarTarget.classList.toggle("hidden", count === 0)
    }
    if (this.hasCountTarget) {
      this.countTarget.textContent = count
    }
  }

  #checkedCount() {
    return this.checkboxTargets.filter(cb => cb.checked).length
  }
}
